import React from "react";
import { Card } from "react-bootstrap";

export default function Bio() {
  return (
    <div>
      <Card>
        <Card.Body>
          <Card.Title style={{ fontSize: 22 }}> Name Of Provider</Card.Title>
          <h4>Speciality in</h4>
          <hr></hr>
          {/* <img
            src={IMG}
            style={{ height: "100%", width: "100%" }}
            alt="promotion"
          /> */}
          <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries, but also the leap into electronic typesetting,
            remaining essentially unchanged. It was popularised in the 1960s
            with the release of Letraset sheets containing Lorem Ipsum passages,
            and more recently with desktop publishing software like Aldus
            PageMaker including versions of Lorem Ipsum.
          </p>
          <Card.Link href="/offers/offers"></Card.Link>
        </Card.Body>
      </Card>
    </div>
  );
}
